import {Component, EventEmitter, Output} from '@angular/core';
declare const $;

@Component({
    selector: 'app-dashboard-side-nav',
    templateUrl: './dashboard-side-nav.component.html',
    styleUrls: ['./dashboard-side-nav.component.css'],
    standalone: false
})
export class DashboardSideNavComponent {
  @Output() onComponentSelected: EventEmitter<any> = new EventEmitter();

  public selectedTab: string = "objects_dashboard";

  public select(name: string) {
    this.onComponentSelected.emit(name);
    this.selectedTab = name;
  }

  public isSelected(name: string): boolean {
    return this.selectedTab == name;
  }
  public toggleMenu()
  {
    var trigger = $('.js-sidemenu-trigger');
    trigger.toggleClass('is-active');
    var parent = trigger.parents('.js-page');
    parent.toggleClass('menu-opened');
  }
}
